/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { List, Checkbox, Button, Segment, Divider, Form, Dimmer, Loader } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();
var formInput = "";

var listScrollStyle = {
  overflow: "auto",
  maxHeight: "30vh"
};

export class EditGSDDML extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      originalFilenames: [],
      filenames: [],
      checkedList: [],
      isGSDMLDimmerActive: false
    };
    this.checkAllCheckbox = React.createRef();
  }

  showGSDMLDimmer = () => this.setState({ isGSDMLDimmerActive: true })
  hideGSDMLDimmer = () => this.setState({ isGSDMLDimmerActive: false })

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "/gsdmlFiles", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        filenames: data,
        originalFilenames: data
      }, () => {
        this.setState({ checkedList: [] }, () => {
          this.buildCheckedList();
          document.getElementById("input-form").value = "";
          this.checkAllCheckbox.current.setState({ checked: false });
        });
      }));
  }

  buildCheckedList = () => {
    const checkedListCopy = [];

    for (let i = 0; i < this.state.filenames.length; i++) {
      checkedListCopy[this.state.filenames[i]] = false;
    }

    this.setState({ checkedList: checkedListCopy });
  }

  toggleCheckbox = (gsdFilename) => {
    const checkedListCopy = this.state.checkedList;

    checkedListCopy[gsdFilename] = !checkedListCopy[gsdFilename];

    this.setState({ checkedList: checkedListCopy });
  }

  toggleAllCheckboxes = (event, data) => {
    const checkedListCopy = [];

    for (let i = 0; i < this.state.filenames.length; i++) {
      checkedListCopy[this.state.filenames[i]] = data.checked;
    }

    this.setState({ checkedList: checkedListCopy });
  }

  handleDeleteGsdmlFiles = async () => {
    let gsdmlFilesToDelete = [];
    let postObject = { gsdFiles: [] };
    let notRemovedFilenames = [];

    // Build an array with the names of all GSDML files to be deleted
    for (let i = 0; i < this.state.filenames.length; i++) {
      if (this.state.checkedList[this.state.filenames[i]]) {
        gsdmlFilesToDelete.push(this.state.filenames[i]);
      }
    }

    if (gsdmlFilesToDelete.length === 0) {
      alert(Strings.SELECT_AT_LEAST_ONE_FILE_TO_DELETE);
    }
    else {
      this.showGSDMLDimmer();

      for (let i = 0; i < gsdmlFilesToDelete.length; i++) {
        // Show the user what file is being removed at the moment
        document.getElementById("removed-filename").innerText = gsdmlFilesToDelete[i];

        postObject.gsdFiles.push(gsdmlFilesToDelete[i]);
        let data = JSON.stringify(postObject);

        await fetch(Constants.REQUEST_IP_ADDRESS + "removeGsdmlFiles_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: data,
          mode: "cors"
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            // Actually don't do anything after a file is removed
          })
          .catch(() => {
            // If there was a problem while removing the file, add the file 
            // name to an array so it can be shown to the user later
            notRemovedFilenames.push(gsdmlFilesToDelete[i]);
          });

        // Clear the array to prepare it for the next file
        postObject.gsdFiles = [];
      }

      // If all the files have been deleted, alert the user
      if (notRemovedFilenames.length === 0) {
        setTimeout(() => {
          alert(Strings.REMOVE_GSDML_SUCCESS);
          this.hideGSDMLDimmer();
          this.retrieveData();
        }, 500);
      }
      // If at least one file was not removed, alert the user, and show a list of all of the files
      // that were not removed
      else {
        let notRemovedFilenamesList = "";

        for (let i = 0; i < notRemovedFilenames.length; i++) {
          notRemovedFilenamesList = notRemovedFilenamesList.concat("\n• " + notRemovedFilenames[i]);
        }

        alert(Strings.THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED + notRemovedFilenamesList);
        this.hideGSDMLDimmer();
        this.retrieveData();
      }

    }
  }

  handleFormChange = (event, data) => {
    formInput = data.value;
  };

  handleSearch = () => {
    let searchFilenames = [];

    for (let i = 0; i < this.state.originalFilenames.length; i++) {

      let upperOriginalFilename = this.state.originalFilenames[i].toUpperCase();
      let upperFormInput = formInput.toUpperCase();

      if (upperOriginalFilename.indexOf(upperFormInput) !== -1) {
        searchFilenames.push(this.state.originalFilenames[i]);
      }
    }

    // Reset the list if the user searches with an empty string
    if (formInput === "") {
      this.setState({ filenames: this.state.originalFilenames });
    }
    else {
      this.setState({ filenames: searchFilenames });
    }
  }

  adjustListMaxHeight = (browserHeight) => {
    if (browserHeight < 600) {
      listScrollStyle = {
        overflowY: "scroll",
        maxHeight: "34vh"
      };
    }
    else if (browserHeight >= 600 && browserHeight < 650) {
      listScrollStyle = {
        overflowY: "scroll",
        maxHeight: "38vh"
      };
    }
    else if (browserHeight >= 650 && browserHeight < 700) {
      listScrollStyle = {
        overflowY: "scroll",
        maxHeight: "39vh"
      };
    }
    else if (browserHeight >= 700 && browserHeight < 800) {
      listScrollStyle = {
        overflowY: "scroll",
        maxHeight: "45vh"
      };
    }
    else if (browserHeight >= 800 && browserHeight < 900) {
      listScrollStyle = {
        overflowY: "scroll",
        maxHeight: "54vh"
      };
    }
    else {
      listScrollStyle = {
        overflowY: "scroll",
        maxHeight: "57vh"
      };
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    const isGSDMLDimmerActive = this.state.isGSDMLDimmerActive;

    const gsdmlList = this.state.filenames.map(filename => (
      <List.Item key={filename}>
        <Checkbox
          label={filename}
          checked={this.state.checkedList[filename]}
          onChange={() => { this.toggleCheckbox(filename); }} />
      </List.Item>
    ));

    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    this.adjustListMaxHeight(browserHeight);

    return (
      <div>
        <Segment style={centerStyle}>

          <Divider horizontal style={dividerStyle}>{Strings.REMOVE_GSDML_FILES}</Divider>

          <Form style={searchStyle} onSubmit={this.handleSearch} >
            <Form.Input
              placeholder={Strings.FILTER_GSDML}
              id="input-form"
              icon="search"
              name="formInput"
              onChange={this.handleFormChange} />
          </Form>

          <Checkbox
            ref={this.checkAllCheckbox}
            label={Strings.SELECT_ALL}
            onChange={this.toggleAllCheckboxes} />

          <Segment style={listStyle}>
            <List divided style={listScrollStyle}>
              {gsdmlList}
            </List>
          </Segment>

          <Button style={buttonStyle} color="teal" content={Strings.REMOVE_SELECTED} onClick={this.handleDeleteGsdmlFiles} />

          <Dimmer active={isGSDMLDimmerActive} >
            <Loader>
              {Strings.REMOVING_GSDML_FILES}
              <p><span id="removed-filename"></span></p>
            </Loader>
          </Dimmer>
        </Segment>
      </div>
    );
  }
}

const centerStyle = {
  textAlign: "center",
  marginLeft: "auto",
  marginRight: "auto",
  width: "50%"
};

const searchStyle = {
  margin: "0 auto"
};

const listStyle = {
  margin: "0 auto"
};

const buttonStyle = {
  width: "50%",
  marginTop: "16px"
};

const dividerStyle = {
  marginTop: "16px",
  marginBottom: "32px",
  marginLeft: "auto",
  marginRight: "auto"
};

export default withRouter(EditGSDDML);